module.exports = __webpack_public_path__ + "static/image2001-d70c58fac444b50ce4915951796915fb.jpeg";